import React from 'react'
import { useMkpProductContext } from 'x/modules/marketplace/MkpProductContext'

export const withMkpProductContextPropsAndRef = (ViewComponent: React.FC | React.ComponentClass) => {
  return React.forwardRef((props: any, ref) => {
    const contextProps = useMkpProductContext()
    return <ViewComponent {...props} ref={ref} mkpProductContext={contextProps} />
  })
}
